// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ChangeEvent, Component, ComponentPropsWithRef } from 'react';

import { S } from './styles';

interface Props extends ComponentPropsWithRef<'input'> {
  onChange: (e: ChangeEvent<any>) => void;
  checked?: boolean;
}

export default class CheckBox extends Component<Props> {
  render() {
    const { onChange, children, className, checked, ...props } = this.props;

    return (
      <S.Wrapper className={className}>
        <S.NativeCheckbox
          type="checkbox"
          onChange={onChange}
          checked={checked}
          {...props}
        />
        <S.Checkbox />
        {children}
      </S.Wrapper>
    );
  }
}
